import { lazy } from 'react';

export const LazyCopaceticMoaAttachmentsReportPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--copacetic-moa-attachments-report-page" */ './copacetic-moa-attachments-report-page'
    ),
);
